function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#00B67A;}\n\t.st1{fill:#DCDCE6;}\n\t.st2{fill:#FFFFFF;}\n");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Trustpilot_ratings_4halfstar-RGB"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-path",
  className: "st0",
  width: 96,
  height: 96
}), /*#__PURE__*/React.createElement("rect", {
  x: 104,
  className: "st0",
  width: 96,
  height: 96
}), /*#__PURE__*/React.createElement("rect", {
  x: 208,
  className: "st0",
  width: 96,
  height: 96
}), /*#__PURE__*/React.createElement("rect", {
  x: 312,
  className: "st0",
  width: 96,
  height: 96
}), /*#__PURE__*/React.createElement("g", {
  id: "Half",
  transform: "translate(416.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 48,
  className: "st1",
  width: 48,
  height: 96
}), /*#__PURE__*/React.createElement("rect", {
  className: "st0",
  width: 48,
  height: 96
})), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  className: "st2",
  d: "M48,64.7L62.6,61l6.1,18.8L48,64.7z M81.6,40.4H55.9L48,16.2l-7.9,24.2H14.4l20.8,15l-7.9,24.2 l20.8-15l12.8-9.2L81.6,40.4L81.6,40.4L81.6,40.4L81.6,40.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M152,64.7l14.6-3.7l6.1,18.8L152,64.7z M185.6,40.4h-25.7L152,16.2l-7.9,24.2h-25.7l20.8,15l-7.9,24.2 l20.8-15l12.8-9.2L185.6,40.4L185.6,40.4L185.6,40.4L185.6,40.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M256,64.7l14.6-3.7l6.1,18.8L256,64.7z M289.6,40.4h-25.7L256,16.2l-7.9,24.2h-25.7l20.8,15l-7.9,24.2 l20.8-15l12.8-9.2L289.6,40.4L289.6,40.4L289.6,40.4L289.6,40.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M360,64.7l14.6-3.7l6.1,18.8L360,64.7z M393.6,40.4h-25.7L360,16.2l-7.9,24.2h-25.7l20.8,15l-7.9,24.2 l20.8-15l12.8-9.2L393.6,40.4L393.6,40.4L393.6,40.4L393.6,40.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M464,64.7l14.6-3.7l6.1,18.8L464,64.7z M497.6,40.4h-25.7L464,16.2l-7.9,24.2h-25.7l20.8,15l-7.9,24.2 l20.8-15l12.8-9.2L497.6,40.4L497.6,40.4L497.6,40.4L497.6,40.4z"
})));

function SvgTrustpilotStars({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 96",
    style: {
      enableBackground: "new 0 0 512 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustpilotStars);
export default __webpack_public_path__ + "static/media/trustpilot-stars.bafe5e5623f54dde788152e4baa95642.svg";
export { ForwardRef as ReactComponent };